import { jsx as _jsx } from "react/jsx-runtime";
import { Contact3DBannerCard } from "../components/Contact3DBannerCard";
import { BANNER_FRONT_TRANSITION_DELAY, BANNER_TRANSITION_TIME, DENIED_BANNER_TRANSITION_TIME } from '../../core/util/BannerTimelineConstants';
export var BannerTimelineItemType;
(function (BannerTimelineItemType) {
    BannerTimelineItemType["Outer"] = "Outer";
    BannerTimelineItemType["Inner"] = "Inner";
    BannerTimelineItemType["Denied"] = "Denied";
    BannerTimelineItemType["Off"] = "Off";
    BannerTimelineItemType["On"] = "On";
})(BannerTimelineItemType || (BannerTimelineItemType = {}));
export function startBannerTimeline(stateData, index, setters, ...timeline) {
    var _a, _b;
    const firstItem = timeline.shift();
    if (firstItem === undefined) {
        return;
    }
    const { timeoutRef, setBannerCard, setDeniedBannerCard, setbgBannerEnabled, setDeniedFrontBannerEnabled, setDeniedBannerEnabled, setFrontBannerEnabled, setBannerOff, } = setters;
    const readAndOut = () => {
        var _a;
        const outTime = (_a = firstItem.outTime) !== null && _a !== void 0 ? _a : BANNER_TRANSITION_TIME;
        if (firstItem.inType === BannerTimelineItemType.Denied) {
            setBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData, contactIndex: 0 }));
        }
        if (firstItem.outType === BannerTimelineItemType.Off) {
            setBannerOff();
        }
        else if (firstItem.outType === BannerTimelineItemType.Outer) {
            setFrontBannerEnabled({ enabled: false, transitionTime: outTime - 50 });
        }
        else if (firstItem.outType === BannerTimelineItemType.Inner) {
            setBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData, contactIndex: index, innerBannerProps: { enabled: false, transitionTime: outTime - 50 } }));
        }
        else {
            setBannerOff();
            setBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData, contactIndex: 0 }));
        }
        if (timeline.length > 0) {
            timeoutRef.current = setTimeout(() => {
                startBannerTimeline(stateData, index + 1, setters, ...timeline);
            }, outTime);
        }
    };
    if (firstItem.inType === BannerTimelineItemType.On) {
        const frontTime = (_a = firstItem.frontTime) !== null && _a !== void 0 ? _a : BANNER_FRONT_TRANSITION_DELAY;
        setbgBannerEnabled({ enabled: true, transitionTime: firstItem.inTime });
        timeoutRef.current = setTimeout(() => {
            setFrontBannerEnabled({ enabled: true, transitionTime: firstItem.inTime - frontTime });
            setDeniedFrontBannerEnabled({ enabled: true, transitionTime: firstItem.inTime - frontTime });
            setBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData, contactIndex: index }));
            timeoutRef.current = setTimeout(() => {
                readAndOut();
            }, firstItem.inTime - frontTime + firstItem.readTime);
        }, (_b = firstItem.frontTime) !== null && _b !== void 0 ? _b : BANNER_FRONT_TRANSITION_DELAY);
    }
    else {
        if (firstItem.inType === BannerTimelineItemType.Inner) {
            setBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData, contactIndex: index, innerBannerProps: { enabled: true, transitionTime: firstItem.inTime } }));
        }
        else if (firstItem.inType === BannerTimelineItemType.Outer) {
            setFrontBannerEnabled({ enabled: true, transitionTime: firstItem.inTime });
            setBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData, contactIndex: index }));
        }
        else {
            setDeniedBannerEnabled({ enabled: true, transitionTime: DENIED_BANNER_TRANSITION_TIME / 2 });
            setDeniedBannerCard(_jsx(Contact3DBannerCard, { bannerStateData: stateData }));
        }
        timeoutRef.current = setTimeout(() => {
            readAndOut();
        }, firstItem.inTime + firstItem.readTime);
    }
}
//# sourceMappingURL=BannerTimeline.js.map